module.exports = __webpack_public_path__ + "static/logo-white-86713d0f92a9447ecdc3aef0bb4072ec.png";